import React from 'react';
import { MobileDataControl } from '../MobileDataControl';

import moment from 'moment';

import './MobileDataMonthly.scss';

/**
 * @param {object} props
 * @param {(value: { year: number, month: number, day: number }) => void} props.onChange
 * @param {{ year: number, month: number }} props.value
 * @param {number[]} props.providedYear
 */
export const MobileDataMonthly = (props) => {
  const { onChange, providedYear, value } = props;
  const now = moment();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const ruleMonth = (month) => {
    const yearNow = moment().year();
    const monthNow = moment().month() + 1;
    const dateNow = moment().date();
    return (
      yearNow === value.year &&
      ((month === monthNow - 1 && dateNow < 9) || month >= monthNow)
    );
  };

  const activeMonth = (month) => {
    const yearNow = moment().year();
    const monthNow = moment().month() + 1;
    const dateNow = moment().date();

    if (value.year !== yearNow) {
      return value.month === month;
    }

    if (
      value.month === monthNow &&
      value.year === yearNow &&
      month === monthNow - 1 &&
      dateNow > 8
    ) {
      onChange({ year: value.year, month: month, day: 0, auto: true });
      return true;
    }

    if (
      value.month === monthNow &&
      value.year === yearNow &&
      month === monthNow - 2 &&
      dateNow < 9
    ) {
      onChange({ year: value.year, month: month, day: 0, auto: true });
      return true;
    }

    if (value.month === 1 && monthNow === 1 && yearNow === value.year) {
      onChange({ year: value.year - 1, month: 12, day: 0, auto: true });
      return true;
    }

    if (ruleMonth(month)) {
      return false;
    }

    return value.month === month;
  };

  const Months = () => {
    return months.map((month, idx) => {
      return (
        <button
          className={`list-month-item${activeMonth(idx + 1) ? ' active' : ''}`}
          disabled={ruleMonth(idx + 1)}
          key={month}
          onClick={() => onChange({ year: value.year, month: idx + 1, day: 0 })}
        >
          {month}
        </button>
      );
    });
  };

  return (
    <div className='feature-genset-MD MobileDataMonthly'>
      <MobileDataControl
        disabledNext={!providedYear.includes(value.year + 1)}
        disabledPrev={!providedYear.includes(value.year - 1)}
        onNext={() => {
          if (value.year + 1 === now.year() && value.month > now.month() + 1) {
            onChange({ year: value.year + 1, month: now.month() + 1, day: 0, auto: true });
          } else {
            onChange({ year: value.year + 1, month: value.month, auto: true });
          }
        }}
        onPrev={() => {
          onChange({ year: value.year - 1, month: value.month, day: 0, auto: true });
        }}
      >
        <div className='year'>{value.year}</div>
      </MobileDataControl>
      <div className='list-month'>
        <Months />
      </div>
    </div>
  );
};
